import { IntegrationType } from '@kcftech/prometheus-client';

export const IntegrationMaxChar = 500;
export const IntegrationAuthMaxChar = 1024;
export const DefaultIntegrationType = IntegrationType.Cmms;
